export const pageview = () => {
  if (!window.fbq) return;
  window.fbq('track', 'PageView');
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}) => {
  if (!window.fbq) return;
  window.fbq('track', name, options);
};
